import React, { Component } from 'react';
import TeamInline from './TeamInlineFR';
import CtaSidebar from './CtaSidebar';

import data from '../data/dataFR.json';

class TeamFR extends Component {
  state = {
    cta: data.cta.sidebar,
    team: data.team_title,
    people: data.team,
  };
  render() {
    return (
      <div>
        <div className="business-banner">
          <div className="hvrbox">
            <img src="/images/_bg/video-02.jpg" alt="Team" className="hvrbox-layer_bottom" />
            <div className="hvrbox-layer_top">
              <div className="container">
                <div className="overlay-text text-left">
                  <h3>{this.state.team.title}</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <a href="/equipe">{this.state.team.title}</a>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="padding-top-large" />

        <div className="bussiness-about-company">
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <div className="col-md-12">
                  <h3>{this.state.team.title}</h3>
                  <p>
                    <strong>{this.state.team.desc}</strong>
                  </p>
                  <TeamInline team={this.state.people} />
                </div>
                <div className="padding-top-middle" />
              </div>

              <div className="col-md-3">
                <CtaSidebar cta={this.state.cta} />
                <div className="padding-top-middle" />
              </div>
            </div>
          </div>
        </div>

        <div className="padding-top-large" />
      </div>
    );
  }
}

export default TeamFR;



// WEBPACK FOOTER //
// ./src/components/TeamFR.js